"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppraisalRelation = void 0;
var AppraisalRelation;
(function (AppraisalRelation) {
    AppraisalRelation["OwnAppraisal"] = "OwnAppraisal";
    AppraisalRelation["Appraiser"] = "Appraiser";
    AppraisalRelation["HrOrDirector"] = "HrOrDirector";
    AppraisalRelation["Peer"] = "Peer";
})(AppraisalRelation = exports.AppraisalRelation || (exports.AppraisalRelation = {}));
//# sourceMappingURL=AppraisalRelationship.js.map